import { z } from "zod";
import { RequestMagicLinkMethodSchema } from "../Enums/RequestMagicLinkMethod";

export const RequestMagicLinkSchema = z.object({
    id: z.string(),
    linkTokenHash: z.string().nullish(),
    requestId: z.string(),
    method: RequestMagicLinkMethodSchema,
    recipient: z.string(),
    expireAt: z.string(), // ISO datetime string
    sessionStartedAt: z.string().nullish(), // ISO datetime string
    sessionExpireAt: z.string().nullish(), // ISO datetime string
    confirmedAt: z.string().nullish(), // ISO datetime string
    openedIpAddress: z.string().nullish(),
    cancelledAt: z.string().nullish(), // ISO datetime string
    createdAt: z.string(), // ISO datetime string
    isExpired: z.boolean(),
    isSendable: z.boolean(),
});

export type RequestMagicLink = z.infer<typeof RequestMagicLinkSchema>;

